import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';
import { AUTHORIZED_MODULE } from '../../configs/moduleNames';

export const AUTHORIZED_REGISTRATION = '_AUTHORIZED_REGISTRATION';
export const AUTHORIZED_LOGIN = '_AUTHORIZED_LOGIN';
export const AUTHORIZED_LOGOUT = '_AUTHORIZED_LOGOUT';
export const AUTHORIZED_CHECK = '_AUTHORIZED_CHECK';
export const FORGOT_PASSWORD = '_FORGOT_PASSWORD';

export const authorizedRegistration = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_REGISTRATION, formValues => (formValues));
export const authorizedLogin = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_LOGIN, formValues => (formValues));
export const authorizedLogout = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_LOGOUT);
export const authorizedLogoutSuccessful = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_LOGOUT + SUCCESSFUL);
export const authorizedLoginSuccessful = createAction(AUTHORIZED_MODULE + AUTHORIZED_LOGIN + SUCCESSFUL, authorizedData => (authorizedData));
export const authorizedLoginFailed = createAction(AUTHORIZED_MODULE + AUTHORIZED_LOGIN + FAILED, formValues => (formValues));
export const authorizedCheck = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_CHECK);
export const authorizedCheckSuccess = createAction(AUTHORIZED_MODULE + AUTHORIZED_CHECK + SUCCESSFUL);
export const authorizedCheckFailed = createAction(AUTHORIZED_MODULE + AUTHORIZED_CHECK + FAILED);

export const forgotPassword = createDeferredAction(AUTHORIZED_MODULE + FORGOT_PASSWORD);
export const forgotPasswordSuccessful = createAction(AUTHORIZED_MODULE + FORGOT_PASSWORD + SUCCESSFUL);
export const forgotPasswordFailed = createAction(AUTHORIZED_MODULE + FORGOT_PASSWORD + FAILED);
